  <mat-slide-toggle [color]="color" [checked]="true" disabled>Actif</mat-slide-toggle>

